/**
 * Created by Sergii on 01.10.2018.
 */
export const UserActions = {
    SHOW_NEW_USER_WND: 'SHOW_NEW_USER_WND',
    UPDATE_NEW_USER_DATA: 'UPDATE_NEW_USER_DATA',
    CLEAR_NEW_USER_DATA: 'CLEAR_NEW_USER_DATA',
    SHOW_MESSAGE_BOX: 'SHOW_MESSAGE_BOX',
    SHOW_MESSAGE_BOX_BASED_ON_DATA: 'SHOW_MESSAGE_BOX_BASED_ON_DATA',
    SHOW_CHANGE_PWD_WND: 'SHOW_CHANGE_PWD_WND',
    UPDATE_CHANGE_PWD_DATA: 'UPDATE_CHANGE_PWD_DATA',
    CLEAR_CHANGE_PWD_DATA: 'CLEAR_CHANGE_PWD_DATA'
};

export const UsersTableActions = {
    LOAD_USERS: 'LOAD_USERS',
    USERS_LOADED: 'USERS_LOADED',
    USER_LOADED: 'USER_LOADED',
    USER_SELECTED: 'USER_SELECTED',
    SELECT_MULTIPLE_USERS: 'SELECT_MULTIPLE_USERS',
    CLEAR_SELECTED_USERS: 'CLEAR_SELECTED_USERS',
    SET_DEFAULT_COLUMNS_WIDTH: 'SET_DEFAULT_COLUMNS_WIDTH',
    COLUMN_RESIZED: 'COLUMN_RESIZED',
    SAVE_COLUMN_WIDTH: 'SAVE_COLUMN_WIDTH',
    LOAD_COLUMNS_WIDTH: 'LOAD_COLUMNS_WIDTH',
    SET_COLUMNS_WIDTH: 'SET_COLUMNS_WIDTH',
    FILTER_USERS: 'FILTER_USERS'
};

export const MessageBoxTypes = {
    DELETE_AMBRY_ID: 'DELETE_AMBRY_ID',
    DELETE_USER: 'DELETE_USER',
    DELETE_MULTIPLE_USERS: 'DELETE_MULTIPLE_USERS',
    DELETE_SECURITY_CLASS: 'DELETE_SECURITY_CLASS',
    DELETE_PROFILE_FORMATS: 'DELETE_PROFILE_FORMATS',
};

export const MessageBoxHeaders = {

};

export const MessageBoxTexts = {

};

export const MessageBoxConfirmBtnTexts = {

};

export const MessageBoxCancelBtnTexts = {

};

export const UserDetailsActions = {
    UPDATE_PROPERTY: 'UPDATE_PROPERTY',
    UPDATE_INPUT: 'UPDATE_INPUT',
    PROFILES_LOADED: 'PROFILES_LOADED',
    CHANGE_AMBRY_ORG_NAME: 'CHANGE_AMBRY_ORG_NAME',
    CHANGE_AMBRY_CLIENT_ID: 'CHANGE_AMBRY_CLIENT_ID',
    ADD_AMBRY_PORT_ID: 'ADD_AMBRY_PORT_ID',
    UPDATE_AMBRY_PROFILE_ID: 'UPDATE_AMBRY_PROFILE_ID',
    REMOVE_AMBRY_PORT_ID: 'REMOVE_AMBRY_PORT_ID',
    CLEAR_USER_DETAILS: 'CLEAR_USER_DETAILS',
    SAVE_LICENSING: 'SAVE_LICENSING',
    SAVE_SECURITY: 'SAVE_SECURITY',
};

export const AmbryKeyActions = {
    SHOW_AMBRY_KEY_DIALOG: 'SHOW_AMBRY_KEY_DIALOG',
    UPDATE_AMBRY_KEY_DATA: 'UPDATE_AMBRY_KEY_DATA',
    SAVE_AMBRY_KEY_DATA: 'SAVE_AMBRY_KEY_DATA',
    AMBRY_KEY_LOADED: 'AMBRY_KEY_LOADED',
};

export const SecurityActions = {
    SAVE: 'SAVE',
};

export const FoldersActions = {
    SAVE_LIST: 'SAVE_LIST',
    SAVE_FORMAT_FOLDERS: 'SAVE_FORMAT_FOLDERS',
    CLEAR_FORMAT_FOLDERS: 'CLEAR_FORMAT_FOLDERS',
};

export const FormatsActions = {
    SAVE_FOLDER_FORMATS: 'SAVE_FOLDER_FORMATS',
    CLEAR_FOLDER_FORMATS: 'CLEAR_FOLDER_FORMATS',
};

export const FORMATS = {
    datasheet: {
        individual: 'idsFormat',
        pedigree: 'pdsFormat',
    },
    spreadsheet: {
        individual: 'ssFormat',
    },
    subtext: 'subtextFormat',
    symbols: 'symbolsFormat',
    pedigreeDropFields: 'dropFieldsFormat',
};